import React from "react";
import { FaStar, FaStarHalfAlt } from "react-icons/fa";

import "./Testimonials.css";

function Testimonials() {
  const testimonials = [
    {
      name: "Ahmed Khan",
      location: "Dubai",
      rating: 5,
      review:
        "Excellent service. My iPhone screen was replaced at my office within an hour. Highly recommended.",
    },
    {
      name: "Sarah Ali",
      location: "Sharjah",
      rating: 4.5,
      review:
        "Very professional technician. Fixed my battery issue quickly and explained everything clearly.",
    },
    {
      name: "Mohammed Hassan",
      location: "Abu Dhabi",
      rating: 4,
      review:
        "Fast response and affordable pricing. My Samsung phone was repaired the same day.",
    },
  ];

  const renderStars = (rating) => {
    const stars = [];

    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 !== 0;

    for (let i = 0; i < fullStars; i++) {
      stars.push(<FaStar key={`star-${i}`} />);
    }

    if (hasHalfStar) {
      stars.push(<FaStarHalfAlt key="half-star" />);
    }

    return stars;
  };

  return (
    <section className="testimonials-section">
      <div className="container">
        <div className="section-heading text-center" data-aos="fade-up">
          <span className="section-badge">Testimonials</span>

          <h2 className="section-title">What Our Customers Say</h2>

          <p className="section-description">
            We take pride in providing reliable and professional mobile repair
            services across UAE.
          </p>
        </div>

        <div className="row">
          {testimonials.map((testimonial, index) => (
            <div
              className="col-lg-4 col-md-6 col-12 mb-3"
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 150}
            >
              <div className="testimonial-card">
                <div className="stars">{renderStars(testimonial.rating)}</div>

                <p className="testimonial-text">"{testimonial.review}"</p>

                <h5>{testimonial.name}</h5>

                <span>{testimonial.location}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Testimonials;
